import AccountEditModal from 'Components/account-edit-modal';
import AccountPasswordModal from 'Components/account-password-modal';
import AccountPaymentModal from 'Components/account-payment-modal';
import AccountBillingModal from 'Components/account-billing-modal';
import AccountInvoicesModal from 'Components/account-invoices-modal';
import AccountAboutModal from 'Components/account-about-modal';
import UserService from 'Services/user';

export default {
	name: 'Account',
	components: {
		AccountEditModal,
		AccountPasswordModal,
		AccountPaymentModal,
		AccountBillingModal,
		AccountInvoicesModal
	},
	created() {
		this.isGettingAccountInfo = true;
		UserService.getAccountInfo()
			.then(response => {
				this.fleetID = response.data.fleetid;
				this.nick = response.data.nick;
				this.firstname = response.data.firstname;
				this.lastname = response.data.lastname;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isGettingAccountInfo = false;
			});

		if (this.isMerchantEnabled) {
			this.isGettingCustomerInfo = true;
			UserService.getCustomerInfo()
				.then(response => {
					this.paymentMethod = response.data.payment_method;

					this.plan.planName = response.data.subscription.plan.plan_name;
					this.plan.displayName = response.data.subscription.plan.display_name;
					this.plan.monthlyPrice = response.data.subscription.plan.m_price;
					this.plan.annualPrice = response.data.subscription.plan.a_price;
					this.plan.currency = response.data.subscription.plan.currency.toUpperCase();
					this.plan.maxDevices = response.data.subscription.plan.max_devices;

					this.billingAddress.firstname = response.data.billing_address.first_name;
					this.billingAddress.lastname = response.data.billing_address.last_name;
					this.billingAddress.address = response.data.billing_address.address;
					this.billingAddress.countrycode = response.data.billing_address.country_code;
					this.billingAddress.company = response.data.billing_address.company;
					this.billingAddress.city = response.data.billing_address.city;
					this.billingAddress.zip = response.data.billing_address.zip;
					this.billingAddress.vatnumber = response.data.billing_address.vat_number;

					this.$store.commit('UPDATE_SUB_INFO', {
						status: response.data.subscription.status,
						plan: {
							name: response.data.subscription.plan.plan_name,
							trialDays: response.data.subscription.plan.trial_days
						}
					});

					if (response.data.subscription.status === 'cancelled') {
						this.$store.commit('UPDATE_MAX_DEVICES', 0);
					} else {
						this.$store.commit('UPDATE_MAX_DEVICES', response.data.subscription.plan.max_devices);
					}
				})
				.catch(error => {
					this.errors.add({
						field: 'apierror',
						msg: 'Unable to get customer payment details'
					});
				})
				.finally(() => {
					this.status = this.$store.state.user.status;
					this.isGettingCustomerInfo = false;
				});
		}
	},
	data() {
		return {
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			isGettingAccountInfo: false,
			isGettingCustomerInfo: false,
			isUpdating: false,
			status: '',
			nick: '',
			fleetID: '',
			APIKey: '',
			firstname: '',
			lastname: '',
			paymentMethod: '',
			plan: {
				planName: '',
				displayName: '',
				monthlyPrice: 0,
				currency: '',
				maxDevices: 0
			},
			billingAddress: {
				company: '',
				countrycode: '',
				firstname: '',
				lastname: '',
				address: '',
				city: '',
				zip: '',
				vatnumber: ''
			}
		};
	},
	computed: {
		isLoading() {
			if (this.isMerchantEnabled) {
				return this.isGettingAccountInfo || this.isGettingCustomerInfo;
			}
			return this.isGettingAccountInfo;
		},
		showPrice() {
			return this.status !== 'in_trial' && this.plan.planName !== 'free';
		}
	},
	methods: {
		showAPIKey() {
			this.isUpdating = true;
			UserService.getAPIKey()
				.then(response => {
					this.APIKey = response.data.apikey;
				})
				.catch(error => {
					this.errors.add({
						field: 'apierror',
						msg: error.response.data.Message
					});
				})
				.finally(() => {
					this.isUpdating = false;
				});
		},
		accountInfoUpdated(credential) {
			this.firstname = credential.firstname;
			this.lastname = credential.lastname;
			// this.nick = credential.email;
		},
		paymentMethodUpdated(paymentMethod) {
			this.paymentMethod = paymentMethod;
		},
		billingAddressUpdated(billingAddress) {
			this.billingAddress = billingAddress;
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/account/script.js